<div class="bg-white rounded-xl border border-gray-200 p-6 h-full shadow-[0_4px_15px_#00000008]">
  <!-- Header Row with Title and Week Navigation -->
  <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-4">
    <h3 class="text-lg font-semibold text-gray-900 m-0">Daily Usage Trend</h3>

    <!-- Week Selector (Only visible if data > 7 days) -->
    <div *ngIf="!loading && totalWeeks > 1" class="flex items-center bg-gray-50 rounded-lg p-1 border border-gray-200">
      <button (click)="changeWeek(-1)" [disabled]="currentWeekIndex === 0"
        class="px-2 py-1 rounded-md border-none outline-none bg-transparent hover:bg-white hover:shadow-sm disabled:opacity-30 disabled:cursor-not-allowed transition-all cursor-pointer">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
        </svg>
      </button>

      <span class="px-3 text-sm font-medium text-gray-700 min-w-[140px] text-center">
        {{ weekRangeLabel }}
      </span>

      <button (click)="changeWeek(1)" [disabled]="currentWeekIndex === totalWeeks - 1"
        class="px-2 py-1 rounded-md border-none outline-none bg-transparent hover:bg-white hover:shadow-sm disabled:opacity-30 disabled:cursor-not-allowed transition-all cursor-pointer">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
        </svg>
      </button>
    </div>
  </div>

  <!-- Chart Area -->
  <div class="relative w-full min-h-[450px] flex items-center justify-center">
    <canvas #dailyUsageCanvas [ngClass]="{'hidden': loading }"></canvas>

    <div *ngIf="loading" class="absolute inset-0">
      <ngx-skeleton-loader [theme]="{ 'border-radius': '8px', height: '450px', width: '100%', margin: '0' }">
      </ngx-skeleton-loader>
    </div>

  </div>
</div>